export default "__VITE_ASSET__tk6ozG8g__"